import { Component } from '@angular/core';

import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { ContainerComponent } from '../../../shared/components/container/container.component';

@Component({
  selector: '[accordion]',
  imports: [NgbAccordionModule, ContainerComponent],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
  host: {
    class: 'position-relative z-0'
  }
})
export class AccordionComponent {

}
